var map = {
	"./copy.svg": "8aac",
	"./goal-plan.svg": "fc79",
	"./lose_icon.svg": "0a9d",
	"./other.svg": "4e6e",
	"./sum-review.svg": "bf9c",
	"./win_icon.svg": "7747",
	"./个人主页.svg": "e8d5",
	"./共享资源.svg": "0614",
	"./基本信息.svg": "18fb",
	"./建设规划.svg": "341e",
	"./我的教学.svg": "38a2",
	"./扁角矩形.svg": "25f1",
	"./教研活动.svg": "feab",
	"./整体情况.svg": "ee93",
	"./虚拟教研室.svg": "2078",
	"./课程教案.svg": "551d",
	"./项目申报.svg": "a309"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";